import React from 'react';
import PropTypes from 'prop-types';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import CloseDialogButton from '@/dialogs_common/CloseDialogButton';
import { WizardProvider, useWizard } from '@/dialogs-routable/profile_edit/WizardContext';
import ProfileEditProgress from '@/dialogs-routable/profile_edit/ProfileEditProgress';
import WizardButtons from '@/dialogs-routable/profile_edit/WizardButtons';
import AboutYou from '@/dialogs-routable/profile_edit/pages/AboutYou';
import YourInvolvement from '@/dialogs-routable/profile_edit/pages/YourInvolvement';
import Opportunities from '@/dialogs-routable/profile_edit/pages/Opportunities';

const PAGE_MAP = {
  about_you:     AboutYou,
  involvement:   YourInvolvement,
  opportunities: Opportunities,
};

function WizardShell() {
  const { activeStepId } = useWizard();
  const PageComponent = PAGE_MAP[activeStepId];

  return (
    <div className="flex flex-col min-h-[500px]">
      <ProfileEditProgress />
      <PageComponent />
      <WizardButtons />
    </div>
  );
}

ProfileEditDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default function ProfileEditDialog(props) {
  return (
    <DialogTemplate className="w-screen max-w-screen-lg">
      <CloseDialogButton onCancel={props.onCancel} />
      <div className="pt-10">
        <WizardProvider onClose={props.onCancel}>
          <WizardShell />
        </WizardProvider>
      </div>
    </DialogTemplate>
  );
}
